@if (popoverTemplate == null) {
  <portal-link
    [params]="routeParams"
    [route]="route"
    [routerLinkActive]="highlight ? 'main-nav__item--active' : ''"
    [routerLinkActiveExact]="false"
  >
    <span class="main-nav__item"><ng-container [ngTemplateOutlet]="content"></ng-container></span>
  </portal-link>
} @else {
  <portal-link
    class="d-block w-auto"
    #tippy
    [delay]="[200, 100]"
    [interactive]="true"
    [params]="routeParams"
    [popover]="true"
    [portalTippy]="popoverTemplate"
    [route]="route"
    [routerLinkActive]="highlight ? 'main-nav__item--active' : ''"
    [routerLinkActiveExact]="false"
    [tippyDisabled]="disableTippy$ | async"
    appendTo="body"
    placement="right-start"
  >
    <span class="main-nav__item"><ng-container [ngTemplateOutlet]="content"></ng-container></span>
  </portal-link>
}

<ng-template #content>
  <ng-container *portalTransclusion="transclusions; name: 'icon'">
    <i class="main-nav__item-icon" [class]="icon"></i>
  </ng-container>

  <span><ng-content></ng-content></span>
</ng-template>
